import { MdcDialogRef } from '@angular-mdc/web';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ContentService } from 'src/app/content.service';

@Component({
  selector: 'app-bekreft-zrapport',
  templateUrl: './bekreft-zrapport.component.html',
  styleUrls: ['./bekreft-zrapport.component.scss']
})
export class BekreftZrapportComponent implements OnInit {

  pending : boolean = false;
  belop_opptalt = new FormControl(null, Validators.required);
  diff_kommentar = new FormControl(null);
  fribillett_utdelt = new FormControl(0, [Validators.required, Validators.min(0)]);
  fribillett_begrunnelse = new FormControl(null);
  kassedata;
  differanse: number | null = null;


  constructor(
    private contentService: ContentService,
    private dialogRef: MdcDialogRef<BekreftZrapportComponent>
  ) { }
  ngOnInit(): void {
    this.hentKasseBeholdning();

    this.belop_opptalt.valueChanges.subscribe(val => {
      this.differanse = (val !== null && val !== '') ? val - this.kassedata.utg_veksel : null;
      if (this.differanse !== 0 && this.differanse !== null) {
        this.diff_kommentar.setValidators([Validators.required]);
      } else {
        this.diff_kommentar.clearValidators();
      }
      this.diff_kommentar.updateValueAndValidity();
    });

    this.fribillett_utdelt.valueChanges.subscribe(val => {
      if (val > 0) {
        this.fribillett_begrunnelse.setValidators([Validators.required]);
      } else {
        this.fribillett_begrunnelse.clearValidators();
      }
      this.fribillett_begrunnelse.updateValueAndValidity();
    });
  }

  hentKasseBeholdning() {
    this.pending = true;
    this.contentService.fetchContent('/salg/xrapport/kassebeholdning').subscribe((res) => {
      if(res) {
        this.kassedata = res;
      }
      this.pending = false;
    }, (err) => {
      alert('Kunne ikke hente kassebeholdning');
      console.error(err);
      this.pending = false;
    });
  }


  kanLukke() {
    return this.belop_opptalt.valid && this.diff_kommentar.valid && this.fribillett_begrunnelse.valid;
  }

  lukkKasse() {
    if(this.belop_opptalt.value || this.belop_opptalt.value === 0) {
      this.dialogRef.close({
        accept: true,
        belop_opptalt: this.belop_opptalt.value,
        diff_kommentar: this.diff_kommentar.value,
        fribillett_utdelt: this.fribillett_utdelt.value,
        fribillett_begrunnelse: this.fribillett_begrunnelse.value
      });
    }
  }

}
